<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <rect width="3.23077" height="3.23077" rx="1.5" fill="#1F2937" />
    <rect
      y="5.38477"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      y="10.7695"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="5.38477"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="5.38477"
      y="5.38477"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="5.38477"
      y="10.7695"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="10.769"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="10.769"
      y="5.38477"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
    <rect
      x="10.769"
      y="10.7695"
      width="3.23077"
      height="3.23077"
      rx="1.5"
      fill="#1F2937"
    />
  </svg>
</template>
